/* @ngInject */

export default class HistoricalLinkCtrl {
	constructor(
		$scope,
		$state,
		Utility,
		$window,
		$timeout,
		$rootScope,
		NavigationService,
		LocalStorageService,
		NotificationService,
		AuthenticationService
	) {
		'ngInject';
		this.$scope = $scope;
		this.$state = $state;
		this.Utility = Utility;
		this.$window = $window;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.NavigationService = NavigationService;
		this.LocalStorageService = LocalStorageService;
		this.NotificationService = NotificationService;
		this.AuthenticationService = AuthenticationService;

		this.init();
	}

	init() {
		this.isBusy = false;
		this.url = undefined;
		this.oldLink = undefined;
		this.newLink =undefined;
		}

	async Replace(url) {		
		if (url == undefined) {
			return;
		}
		try {		
			this.isBusy = true;	
			let incomingUrl = url.toLowerCase().toString();
			if (incomingUrl.includes('dashboard')) {
				let redirectUrl = incomingUrl.replace('dashboard', '');
				if (redirectUrl.includes('localhost:57183')) {
					this.newLink = redirectUrl.replace('http://localhost:57183//', pretorOnlineUrl);
					window.location.href = this.newLink;
				}
				if (redirectUrl.includes('www.pretor.co.za')) {
					this.newLink = redirectUrl.replace('https://www.pretor.co.za//', pretorOnlineUrl);
					window.location.href = this.newLink;
				}
				else{
					window.location.href = redirectUrl;
				}
			}
		}
		catch (err) {
			console.error(`Error while replacing a link: ${err}`);
		} finally {
			this.isBusy = false;
		}
	}
}
